import React from 'react';
import { Navigate } from 'react-router-dom';

// Checks sessionStorage for a valid token and optionally a required role.
// This survives page refreshes unlike React state which resets on every mount.
const PrivateRoute = ({ element, requiredRole }) => {
  const token = sessionStorage.getItem("token");
  const userInfo = JSON.parse(sessionStorage.getItem("userInfo") || "null");

  // No token at all → send to login
  if (!token || !userInfo) {
    return <Navigate to="/login" replace />;
  }

  // Role check — only used for admin route
  if (requiredRole && userInfo.RoleId !== requiredRole) {
    return <Navigate to="/login" replace />;
  }

  return element;
};

export default PrivateRoute;
